import Vue from 'vue'
import { API_ROOT } from '@/config'

const contextPath = 'outcome-stock-movement'

export default (<any>Vue).resource(API_ROOT + contextPath + '{/id}', {})
